<script>
import { frontendURL } from 'dashboard/helper/URLHelper';
import wootConstants from 'dashboard/constants/globals';

export default {
  props: {
    source: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    dashboardPath() {
      return frontendURL(`accounts/${this.accountId}/dashboard`);
    },
    logoSrc() {
      return wootConstants.BRAND_ASSETS.LOGO_NOTEXT;
    },
  },
};
</script>

<template>
  <div class="flex flex-col items-end justify-end">
    <router-link :to="dashboardPath" replace class="flex flex-col items-center">
      <img 
        :src="logoSrc" 
        :alt="name" 
        class="w-5 h-5 object-contain mb-1 rounded-[3px]"
      />
      <span class="text-[0.55625rem] dark:text-white font-semibold">HiCHAT</span>
    </router-link>
  </div>
</template>
